var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.initialized)?_c('div',{attrs:{"id":"wrapper"}},[(_vm.is('guest') && ! _vm.can('write') && ! _vm.can('read') && ! _vm.can('upload'))?_c('Login'):_c('div',{attrs:{"id":"inner"}},[_c('router-view')],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }